<template>
  <div class="modal-content modal-video-player">
    <div class="modal-header">
      <h5 class="modal-title w-75 text-truncate">
        {{ data.filename }}
        <small class="text-muted pl-3"></small>
      </h5>
      <button type="button" aria-label="Close" @click="hideModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <video ref="modalVideo" controls />

      <div class="mt-4 mb-2">
        برای ساخت برنامه‌ از فایل از مسیر زیر استفاده کنید.
      </div>

      <div class="input-group">
        <div class="input-group-prepend">
          <button
            class="btn btn-secondary"
            type="button"
            @click="copyText(data.path, $event)"
          >
            <i class="far fa-1x fa-copy align-baseline"></i>
          </button>
        </div>
        <input
          type="text"
          class="form-control"
          dir="ltr"
          :value="data.path"
          readonly
        />
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <span class="d-block">
        <a
          class="btn btn-sm btn-primary"
          :href="data.url"
          target="_blank"
          :download="data.basename"
        >
          دانلود
        </a>
      </span>
    </div>
  </div>
</template>

<style lang="scss">
@import "~plyr/src/sass/plyr.scss";
.modal-video-player {
  & > .d-flex {
    padding: 1rem;
    border-top: 1px solid #e9ecef;
  }
}
</style>

<script>
import Plyr from "plyr";

export default {
  name: "VideoPlayer",
  data() {
    return {
      player: {}
    };
  },
  props: {
    data: Object
  },
  mounted() {
    this.player = new Plyr(this.$refs.modalVideo);
    this.player.source = {
      type: "video",
      title: this.data.filename,
      sources: [
        {
          src: this.data.url,
          type: `video/${this.data.extension}`
        }
      ]
    };
  },
  beforeDestroy() {
    this.player.destroy();
  },
  computed: {},
  methods: {}
};
</script>
